import { EventRequest, ID } from 'types';
import { ApiUrl, Call, ParseGeneralResponse } from '@api/ApiUtils';

export type BidRequestWithLotIds = Omit<EventRequest, 'lots'> & {
  lot_ids: ID[];
};

interface LoadEventResponse {
  bid_request: BidRequestWithLotIds;
  errors: string[];
  success: boolean;
}

export const loadEvent = async ({ id }: { id: ID; }): Promise<LoadEventResponse> => {
  const url = ApiUrl(`/events/${id}`);

  return Call(
    'get',
    url,
    {},
    ParseGeneralResponse,
    {
      responseDataKeys:
      {
        bid_request: 'bid_request',
      },
    },
  );
};
